import { useState, useCallback } from "react";
import { TimeSheet } from "../types/server";
import { requestHelper } from "../helpers/request-helper";

export { useLogisticTimesheets };

function getTimesheetsApi(type: string, addressId: number, inPerson: boolean) {
  let type_uppercase = type.toUpperCase();
  return requestHelper(
    `
        query timesheet($type: LegacyOrderTypesEnums!, $addressId: Int! , $inPerson: Boolean) {
          proxyCustomerTimesheet(
            type: $type
            addressId: $addressId
            full: true
            inPerson: $inPerson
          ) {
            time_sheets {
              id
              start
              end
              remain_capacity
              disabled
              filled
            }
            date
          }
        }
      `,
    {
      type: type_uppercase,
      addressId,
      inPerson: inPerson,
    }
  ).then((data) => {
    return data.proxyCustomerTimesheet;
  });
}

function useLogisticTimesheets() {
  let [data, setData] = useState<TimeSheet[]>(undefined);
  let [loading, setLoading] = useState(false);
  let [hasError, setError] = useState(false);

  let revalidate = useCallback(function (
    type: string,
    addressId: number,
    inPerson: boolean
  ) {
    setData(undefined);
    setLoading(true);
    setError(false);
    return getTimesheetsApi(type, addressId, inPerson)
      .then((responseData) => {
        setData(responseData);
        return responseData;
      })
      .catch((e) => {
        setError(true);
        return e;
      })
      .finally(() => {
        setLoading(false);
      });
  },
  []);

  // In basket we need to wait address to be selected by user
  // so we need to trigger it manually.

  // useEffect(() => {
  //   revalidate(location);
  // }, []);

  return {
    data,
    isValidating: loading,
    hasError,
    revalidate,
  };
}
